import { defineMessages } from "react-intl";

const messages = defineMessages({
    rehearsalVenue: {
        id: "choir.rehearsalVenue",
    },
});

export default messages;
